import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Switch, FormControlLabel } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

const SelectWidgets = ({ toggleStates, setToggleStates }) => {
  const { t } = useTranslation(['common']);
  const [anchorEl, setAnchorEl] = useState(null);

  // Handle opening and closing of the menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);  // Set anchorEl to the clicked element (button)
  };

  const handleClose = () => {
    setAnchorEl(null);  // Close the menu by setting anchorEl to null
  };

  // Handle toggle changes
  const handleToggle = (widget) => {
    setToggleStates((prevState) => ({
      ...prevState,
      [widget]: !prevState[widget],
    }));
  };

  return (
    <div style={{ position: 'fixed', bottom: '20%', right: '20px', display: 'flex', alignItems: 'center', zIndex: 10, }}>
      {/* Gear Icon Button */}
      <div style={{display:"flex"}}>
        <IconButton onClick={handleClick} >
            <SettingsIcon  />
        </IconButton>
        <p style={{ fontSize: '0.8rem', marginLeft: '8px', cursor: 'pointer' }} >
            {t('common:select_widgets')}
        </p>

      </div>
      {/* "Select Widgets" text next to the icon */}
      {/* <p style={{ fontSize: '0.8rem', marginLeft: '8px', cursor: 'pointer' }} onClick={handleClick}>
        Select Widgets
      </p> */}

      {/* Menu with toggle buttons */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* Menu item for each widget */}
        <MenuItem>
          <FormControlLabel
            control={
              <Switch
                checked={toggleStates.Tasks}
                onChange={() => handleToggle('Tasks')}
                name="Tasks"
                color="primary"
              />
            }
            label={t('common:tasks')}
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Switch
                checked={toggleStates.RecentCases}
                onChange={() => handleToggle('RecentCases')}
                name="RecentCases"
                color="primary"
              />
            }
            label={t('common:recent_cases')}
          />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default SelectWidgets;
